import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { BreakpointMatcherService } from 'src/app/core/services/breakpoint-matcher.service';
import { SessionService } from 'src/app/core/services/session.service';
import { BreakpointState } from '@angular/cdk/layout';

@Component({
  selector: 'app-migration-notice',
  templateUrl: './migration-notice.component.html',
  styleUrls: ['./migration-notice.component.scss'],
})
export class MigrationNoticeComponent implements OnInit {
  articleLink?: string;
  migrationDate = '29/07/2025';
  blocageDate = '24/07/2025';
  breackpointMatche = false;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      articleLink?: string;
      migrationDate?: string;
      blocageDate?: string;
    },
    public dialogRef: MatDialogRef<MigrationNoticeComponent>,
    private sessionService: SessionService,
    private breakpointMatcherService: BreakpointMatcherService
  ) {
    if (data) {
      this.articleLink = this.data.articleLink ?? undefined;
      this.blocageDate = this.data.blocageDate ?? this.blocageDate;
      this.migrationDate = this.data.migrationDate ?? this.migrationDate;
    }
  }

  ngOnInit() {
    this.breakpointMatcherService
      .initObserver('md')
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.breackpointMatche = true;
        } else {
          this.breackpointMatche = false;
        }
      });
  }

  close() {
    this.sessionService.storeMigrationNoticeSeen();
    console.log('close');
    this.dialogRef.close();
  }
}
